<template>
    <div class="clientmessage">
        {{this.clientmessage}}
    </div>
</template>

<script>
export default {
    name:'clientmessage',
    data() {
        return {
           clientmessage:'站内信息'
        }
    },
}
</script>

<style lang="less" scoped>
   .clientmessage{
       width: 100%;
       height: 500px;
       background-color: rgb(255, 255, 255);
   }
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/clientmessage.vue